import React from "react";
import {
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Skeleton,
    Paper,
} from "@mui/material";
import { Table } from "reactstrap";

interface VesselTableSkeletonProps {
    Rows?: number;
}

const VesselTableSkeleton: React.FC<VesselTableSkeletonProps> = ({ Rows }) => {
    const rows = Rows || 10;
    const cols = [
        { width: 30 },  // #
        { width: 200 }, // Vessel name
        { width: 120 }, // Import data
        { width: 120 }, // Assign user
        { width: 120 }, // Edit details
        { width: 120 }, // Configuration
        { width: 150 }, // Voyage reporting
    ];

    return (
        <TableContainer component={Paper}>
            <Table>
                <thead className="table-light">
                    <TableRow>
                        {cols.map((col, index) => (
                            <TableCell key={index}>
                                <Skeleton
                                    variant="rounded"
                                    width={col.width}
                                    height={16}
                                    sx={{ bgcolor: "grey.300" }}
                                />
                            </TableCell>
                        ))}
                    </TableRow>
                </thead>
                <TableBody>
                    {Array.from({ length: rows }).map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {cols.map((col, colIndex) => (
                                <TableCell key={colIndex}>
                                    <Skeleton
                                        variant="rounded"
                                        width={col.width}
                                        height={28}
                                        sx={{ bgcolor: "grey.300" }}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default VesselTableSkeleton;
